import React from 'react';
import PropTypes from 'prop-types';

function ScrollButton({ handleScroll }) {
  return (
    <div className="scroll-button-container">
      <a role="button" className="scroll-button" onClick={handleScroll}>
        <div className="scroll-button-text">
          Next Event
        </div>
        <div className="scroll-button-icon">
          <i className="zolaicon zolaicon-public-chevron-down" />
        </div>
      </a>
    </div>
  );
}

ScrollButton.propTypes = {
  handleScroll: PropTypes.func.isRequired
};

export default ScrollButton;



// WEBPACK FOOTER //
// ./src/components/PublicWebsite/pages/rsvp/RsvpForm/ScrollButton.jsx